import React, { useCallback, useEffect, useState } from 'react';
import { AlertsList } from '../../components/Alerts';
import {
    BREADCRUMB,
    GRADUATIONANNOUNCEMENTS,
    HELPBUTTON,
    PAGETITLE,
    PHOTOCARDS,
    PROMOMSG
} from "../../constants/rootElements";
import { gaGradCatalogBrowsePageLoad } from '../../util/googleAnalytics';
import { Breadcrumb } from '../breadcrumb';
import { TitleBar } from "../catalogBrowseTitle";
import { HelpButton } from '../help';
import GradProductTiles from '../hs-grad/gradProductTiles';
import { useFeeAlertInjectionScript, useGoogleAnalyticsHandler } from "../../hooks";

const ColGradAnncPage = ({ appData }) => {
    const [pbData, setPbData] = useState({})
    const [graduationAnnouncementsData, setGraduationAnnouncementsData] = useState({})
    const [photoCardsData, setPhotoCardsData] = useState({})
    const [altImage, setAltImage] = useState("")
    const [loadGrid, setLoadGrid] = useState(false)
    const [promoMessages, setPromoMessages] = useState([]);
    const [feeAlertRequestData, setFeeAlertRequestData] = useState(null)
    const [googleAnalyticsRequestData, setGoogleAnalyticsRequestData] = useState(null);

    useFeeAlertInjectionScript(feeAlertRequestData)
    const googleAnalytics = useGoogleAnalyticsHandler(googleAnalyticsRequestData);

    const ColGradAnncGraduationAnnouncement = appData?.pageContentData?.find(data => (data.contentType === "ProductBrowseProducts" && data.ctaCheck?.orderSeq === "1"))
    const ColGradAnncPhotoCards = appData?.pageContentData?.find(data => (data.contentType === "ProductBrowseProducts" && data.ctaCheck?.orderSeq === "2"))
    const ColGradAnncBreadcrumb = Boolean(appData?.pageContentData?.find(data => data.contentType === "Navigation"))
    const ColGradAnncTitleBar = appData?.pageContentData?.find(data => data.contentType === "GradPackageBrowseTitle")
    const ProductBrowsePromoMsg = Boolean(
		appData?.pageContentData?.find(
			(data) => data.contentType === 'ProductBrowsePromoMsg'
		)
	);

    const getBreadcrumb = useCallback(() => {
        BREADCRUMB.render(<Breadcrumb pbData={pbData} />);
    }, [graduationAnnouncementsData, photoCardsData])

    const getProductTileGraduationProducts = useCallback((tileData, imageUrl, googleAnalytics) => {
        GRADUATIONANNOUNCEMENTS.render(<GradProductTiles tileData={tileData} altImage={imageUrl} googleAnalytics={googleAnalytics} />);
    }, [])

    const getProductTilePhotoCards = useCallback((tileData, imageUrl, googleAnalytics) => {
        PHOTOCARDS.render(<GradProductTiles tileData={tileData} isPhotoCard={true} altImage={imageUrl} googleAnalytics={googleAnalytics} />);
    }, [])

    const getTitleBar = useCallback(() => {
        PAGETITLE.render(<TitleBar pageContent={ColGradAnncTitleBar} affiliationData={appData?.affiliationData}/>);
    },[])

    const getHelpButton = useCallback(() => {
		HELPBUTTON.render(<HelpButton />);
    }, []);

	const getPromoMsg = useCallback(() => {
		PROMOMSG.render(<AlertsList messages={promoMessages} />);
	}, [promoMessages]);
    
    useEffect(()=>{
        gaGradCatalogBrowsePageLoad();
    },[])
    
    useEffect(() => {
        Object.keys(appData.catalogBrowseData).forEach((key) => {
            if (key !== "metaData") {
                appData.catalogBrowseData[key]?.productGroups && Object.keys(appData.catalogBrowseData[key]?.productGroups).map((catObj) => {
                    const customerNumber = appData.catalogBrowseData.metaData.customerNumber
                    const catalog = appData.catalogBrowseData[key]
                    setFeeAlertRequestData({
                        containerSelector: '#promoMsg',
                        customerId: customerNumber,
                        catalogOsr: catalog.catalogOsr,
                    })
                    setGoogleAnalyticsRequestData({
                        customerNumber,
                        publishedCatalogId: catalog.publishedCatalogId,
                        sourceCatalogType: catalog.sourceCatalogType,
                        catalogOsr: catalog.catalogOsr
                    });
                    setPbData(appData.catalogBrowseData[key])
                    setPromoMessages(appData.catalogBrowseData[key]?.promoMessages);
                    const groupData = { ...appData.catalogBrowseData[key].productGroups[catObj] }
                    if (groupData.groupOsr === ColGradAnncGraduationAnnouncement?.ctaCheck?.groupOsr) {
                        setGraduationAnnouncementsData(groupData)
                    } else if (groupData.groupOsr === ColGradAnncPhotoCards?.ctaCheck?.groupOsr) {
                        setPhotoCardsData(groupData)
                    }
                    return true
                })
            }
            return true
        })
    }, [appData.catalogBrowseData, ColGradAnncGraduationAnnouncement, ColGradAnncPhotoCards])

    useEffect(()=>{
        setAltImage(ColGradAnncGraduationAnnouncement?.imageUrl)
    },[ColGradAnncGraduationAnnouncement])

    const handleScroll = () => {
        setLoadGrid(true);
        removeScrollEvent();
    };
    
    const addScrollEvent = () => {
        window.addEventListener('scroll', handleScroll);
    }

    const removeScrollEvent = () => {
        window.removeEventListener('scroll', handleScroll);
    }

    useEffect(()=>{
        if(document.body.clientWidth<1980) {
            addScrollEvent();
        } else {
            setLoadGrid(true);
        }
        return () => removeScrollEvent();
    },[])

    return (
        <>
            {
                ColGradAnncTitleBar && Object.keys(ColGradAnncTitleBar)?.length > 0 && getTitleBar()
            }
            {
                ProductBrowsePromoMsg && promoMessages?.length > 0 && getPromoMsg()
            }
            {
                ColGradAnncBreadcrumb && ((graduationAnnouncementsData && Object.keys(graduationAnnouncementsData)?.length > 0) || (photoCardsData && Object.keys(photoCardsData)?.length > 0)) && getBreadcrumb()
            }
            {
                ColGradAnncGraduationAnnouncement && graduationAnnouncementsData && Object.keys(graduationAnnouncementsData)?.length > 0 && getProductTileGraduationProducts(graduationAnnouncementsData, altImage, googleAnalytics)
            }
            {
                ColGradAnncPhotoCards && photoCardsData && Object.keys(photoCardsData)?.length > 0 && loadGrid && getProductTilePhotoCards(photoCardsData, altImage, googleAnalytics)
            }
            {getHelpButton()}
        </>
    )
}
export default ColGradAnncPage